// Computed values used for the contract-selector
export enum Universe {
    PARNASSE = 'parnasse',
    INTERNET = 'internet',
    QUATREG_HOME = '4ghome',
    HOMELIVE = 'homelive',
    FIXE = 'fixe',
    MOBILE = 'mobile',
    AIRBOX = 'airbox',
    OPEN = 'open',
    MAISON_PROTEGEE = 'maison-protegee',
    MAISON_PROTEGEE_V2 = 'maison-protegee-v2',
    GENERIC = 'generic', // Used when we are unable to identify the universe
}
